var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 480,
    viewBox: "0 0 512 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 312H440C481.048 312 512 281.048 512 240C512 203.76 486.544 165.112 447.832 160.464C443.84 69.888 368.048 0 272 0C187.208 0 114.96 53.44 97.512 128H88C40.304 128 0 171.96 0 224C0 274.168 37.832 312 88 312ZM88 144H110.64L111.864 137.48C125.096 67.088 192.44 16 272 16C361.72 16 432 82.768 432 168V176H440C473 176 496 209.728 496 240C496 271.928 471.928 296 440 296H88C46.952 296 16 265.048 16 224C16 180.64 48.976 144 88 144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 328H184V368H168V328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 400H184V440H168V400Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.342 338.341L221.656 349.655L197.654 373.657L186.34 362.343L210.342 338.341Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.343 394.341L165.656 405.655L141.655 429.657L130.341 418.343L154.343 394.341Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M221.659 418.343L210.345 429.656L186.343 405.655L197.657 394.341L221.659 418.343Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.342 349.657L141.656 338.344L165.657 362.345L154.344 373.659L130.342 349.657Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192 376H232V392H192V376Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120 376H160V392H120V376Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M328 368H344V408H328V368Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M328 440H344V480H328V440Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M370.341 378.34L381.655 389.653L357.653 413.655L346.34 402.341L370.341 378.34Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314.342 434.34L325.656 445.653L301.654 469.655L290.34 458.341L314.342 434.34Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M381.66 458.342L370.347 469.656L346.345 445.654L357.659 434.34L381.66 458.342Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M290.34 389.658L301.654 378.344L325.656 402.346L314.342 413.66L290.34 389.658Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M352 416H392V432H352V416Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280 416H320V432H280V416Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.0913d55f51b5e3f990b645c86ef72ffe.svg";
export { ForwardRef as ReactComponent };